import React from 'react';
import '../../css/components/QuestionContent/content_play.css';
import Solution from './Solution';
import PartDescription from './LongQuestionFraction/PartDescription';
import ReactDOM from 'react-dom';
// should implement some action here - now only used to preview
var LongQuestionContent = React.createClass({
  getInitialState: function() {
    return {
      kquestion: this.props.kquestion
    }
  },
  componentWillReceiveProps: function(nextProps) {
    var kquestion = this.state.kquestion;
    if (kquestion.concepts) {
      for (var i = 0; i < kquestion.concepts.length; i++) {
        if (this.props.conceptLeafMapping[kquestion.concepts[i]])
          kquestion.conceptLeafInfo = this.props.conceptLeafMapping[kquestion.concepts[i]];
      }
    }
    this.setState({
      kquestion: kquestion
    })
  },
  componentWillMount: function() {

  },
  render: function() {
    var _this = this,
        conceptMap = this.props.conceptLeafMapping;
     console.log(_this.state.kquestion)
    return (
      <div className="long-question">
        <div className="text-desc">
          <span className="question-index">{_this.props.questionIndex+1}</span>
            {
              _this.state.kquestion.concepts && _this.state.kquestion.concepts[0] && conceptMap[_this.state.kquestion.concepts[0]] &&
              <span>
                {conceptMap[_this.state.kquestion.concepts[0]].title + " - "}
              </span>
            }
            <span>{_this.state.kquestion.score + (_this.state.kquestion.score > 1 ? " points" : " point")}</span>
        </div>
        <div className="long-question-parts">
          <div className="content-title">
            {
              _this.state.kquestion.image && <img src={_this.state.kquestion.image} style={{"maxWidth": "500px"}}/>
            }
            <span dangerouslySetInnerHTML={{__html: _this.state.kquestion.description || 'No title'}}></span>
          </div>
          <div className="text-input-wrapper">
            <div className="parts-list">
              {
                _this.state.kquestion.textInputAnswers.map(function(textInput, index) {
                  return (
                    <div key={index} className="part">
                      <PartDescription
                        content={textInput}
                        contentIndex={index}
                        />
                      {
                        _this.state.kquestion.solution[index] && _this.state.kquestion.solution[index].subItems && _this.state.kquestion.solution[index].subItems.length > 0 &&
                        <Solution solution={_this.state.kquestion.solution[index].subItems} />
                      }
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
        {/*
          _this.state.kquestion.solution && _this.state.kquestion.solution.length > 0 &&
          <Solution solution={_this.state.kquestion.solution} />
        */}
        <hr />
      </div>
    )
  },
  componentDidMount: function() {

  },
  componentDidUpdate: function() {
    var __this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(__this)]);
  },
})

export default LongQuestionContent;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/LongQuestion.js
 **/